import React, { useEffect } from 'react';
import './topButton.css';

const TopButton = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        const handleScroll = () => {
            const pageUpButton =
                document.querySelector('.page-up');

            if (!pageUpButton) {
                return;
            }

            if (window.pageYOffset > 300) {
                pageUpButton.style.display = 'flex';
            } else {
                pageUpButton.style.display = 'none';
            }
        };

        handleScroll();

        window.addEventListener(
            'scroll',
            handleScroll
        );

        return () => {
            window.removeEventListener(
                'scroll',
                handleScroll
            );
        };
    }, []);

    return (
        <button
            type="button"
            className="page-up"
            onClick={scrollToTop}
            aria-label="맨 위로 이동"
        >
            <i className="mdi mdi-chevron-up"></i>

            <span>
                TOP
            </span>
        </button>
    );
};

export default TopButton;